<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MUgvNF/media/FC-9781638297123.jpg?1685790453978" alt="This image is the cover for the book Love Poems from the Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love Poems from the Heart
      </h1>
      <p class="bookDescription body article font2">
        <p>The story of my love was written in the form of poetry. My wife passed away on June 8, 2019. The many love poems were written for people who lost their loved ones, young lovers, and most of all it's a journey for dreamers. When you read my poems of love, you will be looking into the essence of my life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry Scrudato
      </h2>
      
      <p class="authorDescription body article"><p>Harry was born on July 20, 1934 in Jersey City, New Jersey to Italian immigrants. His education culminated with the graduationfrom James J Ferris High School in Jersey City. He volunteered for the army draft and after six months of intense training in California at Fort Ord, he was deployed to Schweinfurt, Germany for 18 months during the Cold War and achieved the rank of Specialist-3 as a training aid NCO. Shortly after arriving home, he married and had two daughters and now has five grandchildren. He attended supervisor and management courses at Rutgers University while employed by the New Jersey Turnpike Authority for 27 years as a Section Manager. He is an avid gardener and is known for his delicious tomatoes and &nbsp;figs. He now resides in the town of Secaucus, New Jersey. for the past &nbsp;50 years.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0af47990